import React, { useState } from 'react'
import './Staking.css'
import { Link } from 'react-router-dom'
import StakingModal from 'components/StakingModal'

export default function Staking() {
    const [stakingModal, toggleStakingModal] = useState(false)

    return (
        <div className="staking">
            <div
                onClick={() => toggleStakingModal(true)}
                className="staking__container"
            ></div>
            <StakingModal
                shown={stakingModal}
                close={() => {
                    toggleStakingModal(false)
                }}
            />
        </div>
    )
}
